// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__K8w6q","listingWrapper":"styles_listingWrapper__gVjYi","saveSeasrchWrapper":"styles_saveSeasrchWrapper__t24Cm","adSlotWrap":"styles_adSlotWrap__5l2Vj","housingProjectWrapper":"styles_housingProjectWrapper__KTA1a"};
module.exports.__checksum = "7626b195bbf3"
